export default [
    {
      path: '/guestShareEditPage',
      name: 'guestShareEditPage',
      meta: {
          title: '医生简介'
      },
      component: () => import('@/views/guest/guestShareEditPage')
    },
  ]